import { api } from '@/lib/api';

export interface AuthUserDTO {
  id: string;
  email: string;
  name: string;
  emailVerifiedAt: string | null;
  phoneVerifiedAt: string | null;
  hasCnpj: boolean;
  hasProfile: boolean;
  hasCertificate: boolean;
  hasService: boolean;
}

export interface AuthResponse {
  accessToken: string;
  user: AuthUserDTO;
}

export interface LoginBody {
  email: string;
  password: string;
}
export interface SignupBody {
  email: string;
  password: string;
  name: string;
}
export interface OtpBody {
  channel: 'email' | 'whatsapp';
  code: string;
}
export interface ResendOtpBody {
  channel: 'email' | 'whatsapp';
}

export const authApi = {
  login: (body: LoginBody) => api.post<AuthResponse>('/auth/login', body),
  signup: (body: SignupBody) => api.post<AuthResponse>('/auth/register', body),
  forgot: (email: string) => api.post<void>('/auth/forgot-password', { email }),
  reset: (token: string, password: string) =>
    api.post<void>('/auth/reset-password', { token, password }),
  verifyEmail: (code: string) => api.post<{ verifiedAt: string }>('/auth/verify-email', { code }),
  verifyWhatsapp: (code: string) =>
    api.post<{ verifiedAt: string }>('/auth/verify-whatsapp', { code }),
  resendOtp: (body: ResendOtpBody) => api.post<void>('/auth/resend-otp', body),
  me: () => api.get<AuthUserDTO>('/users/me'),
  loginWithGoogle: (idToken: string) => api.post<AuthResponse>('/auth/google', { idToken }),
};
